import OrderAttentionApprovalRequest from "../../../api/raily/order/attention-approval/order-attention-approval.request";
import OrderAttentionApprovalParams from "./order-attention-approval-params";

const create = (
  params: OrderAttentionApprovalParams,
): OrderAttentionApprovalRequest => {
  return {
    orderId: params.orderId,
  };
};

const orderAttentionApprovalParamsFactory = {
  create,
};

export default orderAttentionApprovalParamsFactory;
